import { useMemo, useState } from "react";
import { PayrollClosingProvider } from "@/Washouts/context/payrollClosing";
import PageLayer from "@/Layouts/views/PageLayer";
import PayrollClosingLayer from "../Layers/PayrollClosing/PayrollClosingLayer";
import { IValuePayrollClosing } from "@/Washouts/types/PayrollClosing";

// MUI
import { Stack, SvgIcon } from "@mui/material";

// Icons
import { ReactComponent as Icon } from "@/assets/icons/header/washouts/PayrollClosing.svg";

export default function PayrollClosing() {
	const [ref, setRef] = useState(null);
	const [headerTitle, setHeaderTitle] = useState("Payroll Closing");

	const value: IValuePayrollClosing = useMemo(
		() => ({
			ref,
			headerTitle,
			setRef,
			setHeaderTitle,
		}),
		[ref, headerTitle]
	);

	return (
		<PayrollClosingProvider value={value}>
			<PageLayer
				title={headerTitle}
				icon={
					<Stack width={1} direction={"row"} justifyContent={"center"} alignItems={"center"}>
						<SvgIcon
							viewBox="-2 -2 24 24"
							className="text-[var(--medium-pink-color)] [&>g]:!fill-[var(--medium-pink-color)] !text-[30px]"
							component={Icon}
						/>
					</Stack>
				}
			>
				<PayrollClosingLayer />
			</PageLayer>
		</PayrollClosingProvider>
	);
}
